import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";

class GetFieldsResult {
    Accepted: boolean;
    Status: number;
    LastUpdateDate: Date | null;
    Fields: FieldReferenceIdAndKeyDto[];

    constructor(accepted: boolean, status: number, lastUpdateDate: Date | null, fields: FieldReferenceIdAndKeyDto[]) {
        this.Accepted = accepted;
        this.Status = status;
        this.LastUpdateDate = lastUpdateDate;
        this.Fields = fields;
    }
}

export default GetFieldsResult;
